import { React, useEffect, useState } from "react";
import "./teams.css";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useLocation, useNavigate } from "react-router-dom";
import CustomModal from "../../components/customModal/customModal";
import { TextInput } from "../../components/formElements/formElements";
import { CREATE_USER_URL, USERLIST_URL, DELETE_USER_URL } from "../../global/API";
import Swal from "sweetalert2";
import Cookies from "js-cookie";
import ProfileAvatar, { formatDateTimeNew } from "../../components/globalFunctions/globalFunctions";
import AgentDetailsModal from "../../components/AgentDetailsModal/AgentDetailsModal";

const Teams = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [userList, setUserList] = useState([]);
  const [viewUser, setViewUser] = useState([]);
  const [userDetails, setUserDetials] = useState({
    role: 2,
    name: "",
    email: "",
    phone: "",
    password: "",
    confirm_password: "",
  });
  const [getModalLayout, setGetModalLayout] = useState(null);
  const [activityTab, setActivityTab] = useState(1);

  const fetchData = async () => {
    setIsLoading(true);
    const jwtToken = Cookies.get("jwtToken");
    const options = {
      method: "GET",
      headers: { Authorization: `Bearer ${jwtToken}` },
    };
    const URL = USERLIST_URL;
    try {
      const response = await fetch(URL, options);
      if (response.ok) {
        const data = await response.json();
        setUserList(data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const navigate = useNavigate();
  const { pathname } = useLocation();

  const onHandleEvent = (event) => {
    const { name, value } = event.target;
    setUserDetials((previousState) => ({ ...previousState, [name]: value }));
  };

  const onHandleSubmit = async (e) => {
    e.preventDefault();

    const { role, name, email, phone, password, confirm_password } = userDetails;

    const formData = new FormData();
    formData.append("role", role);
    formData.append("name", name);
    formData.append("email", email);
    formData.append("phone", phone);
    formData.append("password", password);
    formData.append("confirm_password", confirm_password);

    try {
      const response = await fetch(CREATE_USER_URL, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (response.ok) {
        Swal.fire({
          icon: "success",
          title: "User added successfully",
          timer: 1500,
          showConfirmButton: false,
        });

        // Close modal first
        navigate(-1);

        // Refresh AFTER modal animation completes
        setTimeout(() => {
          fetchData();
        }, 300);

        // 3️⃣ Reset form
        setUserDetials({
          name: "",
          email: "",
          phone: "",
          password: "",
          confirm_password: "",
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleDeleteUser = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const jwtToken = Cookies.get("jwtToken");
        const options = {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${jwtToken}`,
            Accept: "application/json",
          },
        };

        try {
          const response = await fetch(DELETE_USER_URL + id, options);
          if (response.ok) {
            Swal.fire({
              icon: "success",
              title: "User deleted",
              timer: 1200,
              showConfirmButton: false,
            });

            // Refresh list
            fetchData();
          } else {
            console.error("Failed to delete user");
            Swal.fire({
              title: "Error",
              text: "Failed to delete user.",
              icon: "error",
            });
          }
        } catch (error) {
          console.error("Error deleting user:", error);
          Swal.fire({
            title: "Error",
            text: "Error deleting user.",
            icon: "error",
          });
        }
      }
    });
  };

  const userListView = () => {
    return userList.data.map((users) => {
      const { id, name, phone, email, password, updated_at } = users;
      const date = new Date(updated_at);
      const formatted = date.toLocaleString("en-US", {
        year: "numeric",
        month: "short",
        day: "2-digit",
        // hour: "2-digit",
        // minute: "2-digit",
      });
      return (
        <tr key={id}>
          <td style={{ width: "10px", paddingRight: "0" }}>
            <div className="form-check">
              <input type="checkbox" className="form-check-input" />
              <label className="form-check-label"></label>
            </div>
          </td>
          <td>
            <div className="d-flex align-items-center user-title">
              <i className="profile-pic">
                <ProfileAvatar name={name} />
              </i>
              <button
                className="btn text-dark fw-medium "
                onClick={() => {
                  const modifiedData = viewUser.filter((user) => user.id === id);
                  if (modifiedData.length === 0) {
                    setViewUser((prevState) => [...prevState, users]);
                  }
                }}
              >
                {name}
              </button>
            </div>
          </td>
          <td>Real estate agent</td>
          <td>{email}</td>
          <td>{phone}</td>
          <td>User</td>
          <td>{formatted}</td>
          <td className="action-btns">
            <div className="d-flex gap-2">
              <button type="button" className="btn btn-soft-danger btn-sm" onClick={() => handleDeleteUser(id)}>
                <Icon icon="solar:trash-bin-minimalistic-2-broken" className="align-middle fs-18" />
              </button>
            </div>
          </td>
        </tr>
      );
    });
  };

  const usersLoadingView = () => {
    return (
      <tr className="loading-hover">
        <td className="property-loader preloader">
          <div className="loading">
            <div className="loading__letter">L</div>
            <div className="loading__letter">o</div>
            <div className="loading__letter">a</div>
            <div className="loading__letter">d</div>
            <div className="loading__letter">i</div>
            <div className="loading__letter">n</div>
            <div className="loading__letter">g</div>
            <div className="loading__letter">.</div>
            <div className="loading__letter">.</div>
            <div className="loading__letter">.</div>
          </div>
        </td>
      </tr>
    );
  };

  const noUsersView = () => {
    return (
      <tr className="loading-hover">
        <td className="no-data-found">
          <Icon icon="solar:home-broken" className="fs-32 text-primary avatar-title"></Icon>
          No User data found
        </td>
      </tr>
    );
  };

  const renderView = () => {
    if (isLoading) {
      return usersLoadingView();
    } else if (userList.status === "Not Found") {
      return noUsersView();
    } else if (userList.status === "Success") {
      return userListView();
    }
  };

  const renderUserForm = () => {
    return (
      <form onSubmit={onHandleSubmit}>
        <div className="row">
          <div className="col-12 mb-3">
            <TextInput id="fullName" type="text" onChange={onHandleEvent} label="Full Name" name="name" />
          </div>
          <div className="col-12 mb-3">
            <TextInput id="email" type="email" onChange={onHandleEvent} label="Email" name="email" />
          </div>
          <div className="col-12 mb-3">
            <TextInput id="phone" type="number" onChange={onHandleEvent} label="Phone Number" name="phone" />
          </div>
          <div className="col-12 mb-3">
            <TextInput id="password" type="text" onChange={onHandleEvent} label="Password" name="password" />
          </div>
          <div className="col-12 mb-3">
            <TextInput id="confirmPassword" type="text" onChange={onHandleEvent} label="Confirm Password" name="confirm_password" />
          </div>
        </div>
        <div className="row justify-content-end g-2">
          <div className="col-2">
            <button type="submit" className="btn btn-outline-primary w-100">
              Save
            </button>
          </div>
        </div>
      </form>
    );
  };

  return (
    <div className="page-content user-page">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Team list</h4>

              <div className="page-title-box-content">
                <button
                  type="button"
                  className="btn"
                  onClick={() => {
                    navigate("register-agent");
                  }}
                >
                  Add Agent
                </button>
                <button type="button" className="refresh-button" title="Reset">
                  <i className="ri-refresh-line"></i>
                </button>
                <form className="app-search">
                  <div className="position-relative">
                    <input type="search" className="form-control border-0" placeholder="Search..." autoComplete="off" name="searchValue" />
                    <i className="ri-search-line search-widget-icon"></i>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="table-responsive">
                <table className="table align-middle text-nowrap table-hover table-centered property-table">
                  <thead className="bg-light-subtle">
                    <tr>
                      <th style={{ width: "10px" }}>
                        <div className="form-check">
                          <input type="checkbox" className="form-check-input" />
                          <label className="form-check-label"></label>
                        </div>
                      </th>
                      <th>Name & Photo</th>
                      <th>Title</th>
                      <th>Email</th>
                      <th>Phone</th>
                      <th>Role</th>
                      <th>Created date</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>{renderView()}</tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div className="pagination-grid"></div>
        <CustomModal renderItem={renderUserForm} title="Add Agent" showHeader={true} position="right" visible={pathname.toLowerCase().includes("register-agent")} />
        <div className="minimize-grid">
          {viewUser.length >= 1 &&
            viewUser.map((item) => (
              <CustomModal
                key={item.id}
                renderItem={() => <AgentDetailsModal item={item} getModalLayout={getModalLayout} activityTab={activityTab} setActivityTab={setActivityTab} />}
                title="Agent details"
                secondaryTitle={item.name}
                visible={true}
                showLeftSidebarIcon={true}
                showCreateDate={true}
                showMoreIcon={true}
                createdDate={formatDateTimeNew(item.created_at)}
                showLayoutIcon={viewUser.length === 1}
                getModalLayout={setGetModalLayout}
                onHandleClose={() => {
                  const modifiedData = viewUser.filter((user) => user.id !== item.id);
                  setViewUser(modifiedData);
                }}
              />
            ))}
          {/* 
          {viewUser.length >= 1 &&
            viewUser.map((item) => (
              <CustomModal
                key={item.id}
                renderItem={() => renderAgentDetails(item)}
                title={"Agent details"}
                secondaryTitle={item.name}
                // title={item.name}
                visible={true}
                showLeftSidebarIcon={true}
                showCreateDate={true}
                showMoreIcon={true}
                createdDate={formatDateTimeNew(item.created_at)}
                showLayoutIcon={viewUser.length === 1}
                getModalLayout={setGetModalLayout}
                onHandleClose={() => {
                  const modifiedData = viewUser.filter((user) => user.id !== item.id);
                  setViewUser(modifiedData);
                }}
              />
            ))} */}
        </div>
      </div>
    </div>
  );
};

export default Teams;
